//styles
import '../styles/subtitle.css'
const Subtitle = ({children}) => {
    return (
      <div className='subtitle'>{children}</div>
    )
  }
  
  export default Subtitle